import { MemberInfoTypes } from '@actions/memberInfo/memberInfoTypes';
import Cookies from 'universal-cookie';
import { CustomizeWelcomeActionType } from '@actions/customizeWelcome/customizeWelcomeTypes';
import {
  setCartCustomerName,
  setCartCustomerPhone,
} from '@actions/cartV2/cartV2Action';
import {
  setWelcomeCustomerName,
  setWelcomeCustomerPhone,
} from '@actions/customizeWelcome/customizeWelcomeAction';
import MemberInfoService from '../../services/memberInfo/memberInfoService';

const cookies = new Cookies(null, {
  path: '/',
  maxAge: process.env.REACT_APP_COOKIE_MAX_AGE
    ? Number(process.env.REACT_APP_COOKIE_MAX_AGE)
    : undefined,
});

export const getMemberPoint: (
  storeId: string,
  mobile: string,
  country: string
) => any = async (storeId, mobile, country) => {
  try {
    const res = await MemberInfoService.getMemberPoint(
      storeId,
      mobile,
      country
    );
    return await Promise.resolve(res.data);
  } catch (err) {
    console.log('axios error', err);
    throw err;
  }
};

export const setIsOnlineMemberEnable: (boolVal) => any =
  (boolVal) => async (dispatch) => {
    dispatch({
      type: MemberInfoTypes.SET_ENABLED,
      payload: boolVal,
    });
  };

export const refreshMemberInfo: () => any = () => (dispatch) => {
  dispatch({
    type: MemberInfoTypes.REFRESH_MEMBER_INFO,
    payload: '',
  });
};

export const setIsLogin: (boolVal) => any = (boolVal) => async (dispatch) => {
  dispatch({
    type: MemberInfoTypes.SET_IS_LOGIN,
    payload: boolVal,
  });
};

export const setIsMember: (boolVal) => any = (boolVal) => async (dispatch) => {
  dispatch({
    type: MemberInfoTypes.SET_IS_MEMBER,
    payload: boolVal,
  });
};

export const getMemberInfo: (storeUuid: string) => any =
  (storeUuid) => async (dispatch, getState) => {
    let { memberToken } = getState().memberInfoReducer;
    if (!memberToken) memberToken = cookies.get('member-token');
    if (!memberToken) return Promise.resolve({});

    const res = await MemberInfoService.getMemberInfo(memberToken, storeUuid);

    dispatch(setCartCustomerName(res.data?.data?.name));
    dispatch(setWelcomeCustomerName(res.data?.data?.name));
    return Promise.resolve(res.data.data);
  };

export const checkPhoneIsFullMember: (
  mobile: string,
  country: string,
  storeUuid: string,
  redirectToken: string
) => any = (mobile, country, storeUuid, redirectToken) => async (dispatch) => {
  const res = await MemberInfoService.checkPhoneIsFullMember(
    mobile,
    country,
    storeUuid,
    redirectToken
  );

  return Promise.resolve(res.data.data);
};

export const checkPhoneAndSetIsFullMember: (
  mobile: string,
  country: string,
  storeUuid: string,
  redirectToken: string
) => any = (mobile, country, storeUuid, redirectToken) => async (dispatch) => {
  const res = await MemberInfoService.checkPhoneIsFullMember(
    mobile,
    country,
    storeUuid,
    redirectToken
  );

  dispatch({
    type: MemberInfoTypes.SET_IS_MEMBER,
    payload: res.data.data.phoneFullMember,
  });

  cookies.set('member-phone', { mobile, country, storeUuid, redirectToken });

  return Promise.resolve(res.data.data);
};

export const sendMemberCaptcha: (
  storeUuid: string,
  redirectToken: string
) => any = (storeUuid, redirectToken) => async (dispatch, getState) => {
  const { country, phone } = getState().memberInfoReducer;

  const res = await MemberInfoService.sendMemberCaptcha(
    phone,
    country,
    storeUuid,
    redirectToken
  );

  dispatch({
    type: MemberInfoTypes.SET_CAPTCHA_TOKEN,
    payload: res.data.data,
  });

  return Promise.resolve(res.data);
};

export const registerMemberCaptcha: (captcha) => any =
  (captcha) => async (dispatch, getState) => {
    const { captchaToken } = getState().memberInfoReducer;
    const res = await MemberInfoService.registerMemberCaptcha(
      captcha,
      captchaToken
    );
    cookies.set('member-token', res.data.data.memberToken);

    dispatch({
      type: MemberInfoTypes.SET_MEMBER_TOKEN,
      payload: res.data.data.memberToken,
    });

    return Promise.resolve(res.data);
  };

export const verifyMemberCaptcha: (captcha) => any =
  (captcha) => async (dispatch, getState) => {
    const { captchaToken } = getState().memberInfoReducer;
    const res = await MemberInfoService.verifyMemberCaptcha(
      captcha,
      captchaToken
    );
    cookies.set('member-token', res.data.data.memberToken);
    dispatch({
      type: MemberInfoTypes.SET_MEMBER_TOKEN,
      payload: res.data.data.memberToken,
    });

    return Promise.resolve(res.data);
  };

export const updateMemberInfo: (memberInfo) => any =
  (memberInfo) => async (dispatch, getState) => {
    const { memberToken } = getState().memberInfoReducer;
    const res = await MemberInfoService.updateMemberInfo(
      memberInfo,
      memberToken
    );

    return Promise.resolve(res.data);
  };

export const logoutMemberToken: () => any =
  () => async (dispatch, getState) => {
    const { memberToken } = getState().memberInfoReducer;

    await MemberInfoService.logoutMemberToken(memberToken);

    refreshMemberInfo();
  };

export const deleteMember: () => any = () => async (dispatch, getState) => {
  const { memberToken } = getState().memberInfoReducer;
  await MemberInfoService.deleteMember(memberToken);
  cookies.remove('member-token');
  cookies.remove('member-phone');

  dispatch(refreshMemberInfo());
};

export const getUserTerms: (storeUuid: string) => any =
  (storeUuid) => async () => {
    const res = await MemberInfoService.getUserTerms(storeUuid);

    return Promise.resolve(res.data);
  };

export const setMemberInfoPhone: (selectedMemberPhone: any) => any =
  (selectedMemberPhone) => async (dispatch) => {
    dispatch({
      type: MemberInfoTypes.SET_CURRENT_PHONE,
      payload: {
        phone: selectedMemberPhone?.phone,
        areaCode: selectedMemberPhone?.areaCode,
        country: selectedMemberPhone?.areaCode?.country,
      },
    });
  };

export const initMemberInfo: (storeUuid) => any =
  (storeUuid) => async (dispatch, getState) => {
    const { enabled } = getState().memberInfoReducer;

    if (!storeUuid || !enabled) return;

    const token = cookies.get('member-token');
    if (!token) {
      const memberPhone = cookies.get('member-phone');
      if (!memberPhone) {
        return;
      }

      const { mobile, country, redirectToken } = memberPhone;

      const res = await MemberInfoService.checkPhoneIsFullMember(
        mobile,
        country,
        storeUuid,
        redirectToken
      );

      dispatch({
        type: CustomizeWelcomeActionType.SET_WELCOME_PHONE,
        payload: mobile,
      });

      dispatch({
        type: MemberInfoTypes.SET_IS_MEMBER,
        payload: res.data.data.phoneFullMember,
      });

      dispatch({
        type: MemberInfoTypes.SET_CURRENT_PHONE,
        payload: {
          phone: mobile,
          country,
        },
      });

      dispatch(setWelcomeCustomerName(res.data?.data?.memberName));
      dispatch(setWelcomeCustomerPhone(mobile));

      dispatch(setCartCustomerName(res.data?.data?.memberName));
      dispatch(setCartCustomerPhone(mobile));

      const allElements: any = document.getElementsByTagName('*');
      for (let i = 0; i < allElements.length; i++) {
        if (allElements[i].id == 'phone') allElements[i].disabled = true;
        if (allElements[i].id == 'areaCodeDropDownMenu')
          allElements[i].disabled = true;
      }
      return;
    }

    const res = await MemberInfoService.getMemberInfo(token, storeUuid);
    if (!res?.data?.data) {
      cookies.remove('member-token');
      return;
    }

    dispatch({
      type: MemberInfoTypes.INIT_MEMBER_INFO,
      payload: {
        isLogin: true,
        isMember: true,
        phone: res.data?.data?.phone,
        token,
      },
    });

    dispatch(setWelcomeCustomerName(res.data?.data?.name));
    dispatch(setWelcomeCustomerPhone(res.data?.data?.phone));

    dispatch(setCartCustomerName(res.data?.data?.name));
    dispatch(setCartCustomerPhone(res.data?.data?.phone));

    const allElements: any = document.getElementsByTagName('*');
    for (let i = 0; i < allElements.length; i++) {
      if (allElements[i].id == 'phone') allElements[i].disabled = true;
      if (allElements[i].id == 'areaCodeDropDownMenu')
        allElements[i].disabled = true;
    }
  };

export const setCurrentSelectedPhone: (data) => any =
  (data) => async (dispatch) => {
    dispatch({
      type: MemberInfoTypes.SET_CURRENT_PHONE,
      payload: data,
    });
  };
